export type ClinicalDataAvailability =
  | "loading"
  | "empty"
  | "available"
  | "stale"
  | "unavailable";

/**
 * Turns React Query's independent data/loading/error fields into the product
 * states used by patient-record surfaces. In particular, an error with cached
 * data is stale (keep rendering it); an error without data is unavailable.
 */
export function getClinicalDataAvailability({
  data,
  error,
  isLoading,
}: {
  data: unknown;
  error: unknown;
  isLoading: boolean;
}): ClinicalDataAvailability {
  if (error) return data === undefined ? "unavailable" : "stale";
  if (isLoading || data === undefined) return "loading";
  if (Array.isArray(data) && data.length === 0) return "empty";
  return "available";
}
